import React from "react";
import BookingDetails from "./BookingDetails/BookingDetails";
import { BookingSummary } from "./BookingSummary";

export const EnginePowerTax = () => {
  return (
    <>
      <BookingSummary premiumType="HORSE_POWER" />
      <BookingDetails premiumType="HORSE_POWER" />
    </>
  );
};
